import type { IHekate, IHekateContent, IHekateHistory } from '@/types/Data'
import type { IGetHekateHistory, IPayloadHekate } from '@/types/Request'
import BaseService from '../BaseService'

export default class HekateServices extends BaseService {
  GetGdprList() {
    return this.GET<IHekate[]>(this.PATHS.HEKATE_GDPR)
  }

  CreateGdpr(data: IPayloadHekate) {
    return this.POST<void>(this.PATHS.HEKATE_GDPR, data)
  }

  UpdateGdpr(data: IPayloadHekate, rootId: string) {
    return this.PUT<void>(this.PATHS.HEKATE_GDPR, data, { rootId })
  }

  DeleteGdpr(rootId: string) {
    return this.DELETE<void>(this.PATHS.HEKATE_GDPR, { rootId })
  }

  GetGdprContentList(rootId: string) {
    return this.GET<IHekateContent[]>(this.PATHS.GET_GDPR_CONTENT_LIST, { rootId })
  }

  GetGdprHistory(payload: IGetHekateHistory) {
    return this.GET<IHekateHistory[]>(this.PATHS.GET_GDPR_HISTORY, payload)
  }
}
